import { Flex, Form } from 'antd';
import styled from 'styled-components';

export const StyledFormItem = styled(Form.Item)`
  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::before {
    display: none;
  }
`;

export const StyledContainer = styled.div`
  padding: 40px 20px;
`;

export const SelectedTag = styled(Flex)`
  padding-inline: 8px;
  padding-block: 4px;
  background-color: #f4f4f4;
  border: 1px solid #dbdde2;
  border-radius: 4px;
  gap: 8px;
  align-items: center;
`;

export const StyledLoading = styled(Flex)`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  padding: 0 8px 8px;
  z-index: 2;
  margin-top: -1px;
  background-color: #ffffff;
  border: 1px solid #ccced1;
  border-top: none;
`;
